<template>
  <div>
    <v-row>
          <p>Dados Técnicos do cabo</p>
    </v-row>
      <v-row>

       <v-col cols="12" md="3">
        <v-select
          class="my-5"
          v-model="device.color"
          :items="colorOptions"
          label="Cor"
          item-text="text"
          item-value="value"
          dense
        >
        </v-select>
      </v-col>

       <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.gauge"
          label="Bitola (mm2)"
          v-bind:options="optionsInteger"
        />
      </v-col>
        


         <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.voltageInsulation"
          label="Tensão de isolação (V)"
          v-bind:options="optionsInteger"
        />
      </v-col>

     
      
      <v-col cols="12" md="3">
        <v-select
          class="my-5"
          v-model="device.voltageType"
          :items="acDcOptions"
          label="AC/DC"
          item-text="text"
          item-value="value"
          dense
        >
        </v-select>
      </v-col>

      </v-row>
  
  </div>

</template>



<script>
export default {
  components: {
    // EditModulo
  },

  name: "edit-cable",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
            optionsBr: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      optionsInteger: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 0,
      },
        acDcOptions:[
        {value:"ac",text:"AC"},
        {value:"dc",text:"DC"},
        
      ],
      colorOptions:[
        {value:"red",text:"Vermelho"},
        {value:"black",text:"Preto"},
        {value:"green",text:"Verde"},
        
      ],
      selected: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  methods: {
    
    
  },
};
</script>
